<div class="header">
    <!-- <cd-header-banner
    ></cd-header-banner> -->
    <cd-header-navbar></cd-header-navbar>
</div>
